// Ty gia USDT tu dong theo Upbit KRW-USDT tren trang Cai dat vi (backend lib/ty_gia_usdt.js trangThai, qua tyGia cua
// GET /api/admin/wallet/config). Ham thuan: trang thai de hien va ty gia se dung sau khi luu ban nhap.
export type TuDong = { bat: boolean; phut: number; lechToiDa: number; chenhLech: number };
export type TyGiaUsdt = {
  giaDung: number; nguon: string; tuDong: TuDong;
  tep: { giaNguon?: number; luc?: string; lucGiaoDich?: string; loi?: { luc: string; lyDo: string; giaNguon?: number } | null; hong?: boolean } | null;
};
export type MoTa = {
  giaDung: number; theoUpbit: boolean; giaUpbit: number | null; luc: string | null;
  loi: { luc: string; lyDo: string } | null; hong: boolean;
};

export function moTa(t: TyGiaUsdt | null | undefined): MoTa | null {
  if (!t) return null;
  const tep = t.tep;
  const giaUpbit = tep && typeof tep.giaNguon === 'number' && tep.giaNguon > 0 ? tep.giaNguon : null;
  const lucNhan = giaUpbit !== null && tep?.luc ? tep.luc : null;
  // lan doc bi tu choi chi hien khi moi hon lan nhan gia cuoi
  const loi = tep?.loi && (!lucNhan || Date.parse(tep.loi.luc) > Date.parse(lucNhan)) ? { luc: tep.loi.luc, lyDo: tep.loi.lyDo } : null;
  return { giaDung: t.giaDung, theoUpbit: t.tuDong.bat && giaUpbit !== null, giaUpbit, luc: lucNhan, loi, hong: tep?.hong === true };
}

// Ty gia he A se dung voi ban nhap (cong tac, chenh lech, gia go tay): cung cong thuc backend nap_cms.giaUsdt.
export function giaSauLuu(t: TyGiaUsdt | null | undefined, tuDong: Partial<TuDong> | undefined, giaTay: number): number {
  const bat = tuDong?.bat ?? t?.tuDong.bat ?? true;
  const chenhLech = tuDong?.chenhLech ?? t?.tuDong.chenhLech ?? 0;
  const giaUpbit = moTa(t)?.giaUpbit ?? null;
  if (bat && giaUpbit !== null) return Math.floor(giaUpbit * (100 + chenhLech) / 100);
  return Math.floor(giaTay || 0);
}
